<div class="numero_piezas">{{ numeroSegmentaciones }}</div>
<div class="descripcion">Segmentaciones</div>
